import { useRef, useEffect } from 'react';
import { CreditCardAddReturnResult } from 'constants/credit-card';
import useLocation from 'hooks/useLocation';
import { removeRedirectUrlParams, parseExtraServiceCardAddRedirectUrl } from 'libs/utils/threeDS2';

const useExtraServiceCardAuthRedirectResultEffect = (orderType, callbacks) => {
  const {
    relativeUrl,
    replaceHistoryState,
    urlQuery
  } = useLocation();
  const onSuccessRef = useRef(callbacks.onSuccess);
  const onFailureRef = useRef(callbacks.onFailure);
  const onNoResultRef = useRef(callbacks.onNoResult);
  const urlQueryRef = useRef(urlQuery);
  onSuccessRef.current = callbacks.onSuccess;
  onFailureRef.current = callbacks.onFailure;
  onNoResultRef.current = callbacks.onNoResult;
  urlQueryRef.current = urlQuery;
  useEffect(() => {
    const {
      cardId,
      orderId,
      cardAddResult
    } = parseExtraServiceCardAddRedirectUrl(urlQueryRef.current, orderType);

    if (!cardAddResult || !orderId) {
      var _onNoResultRef$curren;

      (_onNoResultRef$curren = onNoResultRef.current) === null || _onNoResultRef$curren === void 0 ? void 0 : _onNoResultRef$curren.call(onNoResultRef);
      return;
    }

    if (cardAddResult === CreditCardAddReturnResult.Success && cardId) {
      onSuccessRef.current({
        cardId,
        orderId
      });
    } else if (cardAddResult === CreditCardAddReturnResult.Fail) {
      onFailureRef.current({
        orderId
      });
    }

    replaceHistoryState(removeRedirectUrlParams(relativeUrl, urlQueryRef.current));
  }, [orderType, relativeUrl, replaceHistoryState]);
};

export default useExtraServiceCardAuthRedirectResultEffect;